import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import API from '../services/api';

const ZONAS = ['Europe/Madrid','Europe/London','Europe/Paris','Europe/Berlin','America/New_York','America/Los_Angeles','America/Mexico_City','America/Bogota','America/Buenos_Aires'];

function Toggle({value, onChange}) {
  return (
    <div style={{width:44,height:24,borderRadius:12,cursor:'pointer',position:'relative',transition:'background 0.2s',flexShrink:0,background:value?'#378ADD':'#ddd'}} onClick={onChange}>
      <div style={{width:18,height:18,background:'white',borderRadius:'50%',position:'absolute',top:3,left:3,transition:'transform 0.2s',boxShadow:'0 1px 3px rgba(0,0,0,0.2)',transform:value?'translateX(20px)':'translateX(0)'}} />
    </div>
  );
}

function ToggleRow({label, desc, value, onChange, last}) {
  return (
    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'13px 0',borderBottom:last?'none':'0.5px solid #f0f0ed'}}>
      <div><div style={{fontSize:14,fontWeight:500,color:'#1a1a1a'}}>{label}</div><div style={{fontSize:12,color:'#aaa',marginTop:2}}>{desc}</div></div>
      <Toggle value={value} onChange={onChange} />
    </div>
  );
}

function ConfigAdmin({form, set, guardar, guardando, msg, error}) {
  return (
    <>
      {msg && <div style={s.ok}>{msg}</div>}
      {error && <div style={s.err}>{error}</div>}
      <div style={s.cols}>
        {/* COLUMNA IZQUIERDA */}
        <div style={s.col}>
          <div style={s.card}>
            <div style={s.cardTitle}>🏢 Empresa</div>
            <div style={s.field}><label style={s.label}>Nombre de la empresa</label>
              <input style={s.input} value={form.empresa_nombre||''} onChange={e=>set('empresa_nombre',e.target.value)} /></div>
            <div style={s.field}><label style={s.label}>Email de contacto</label>
              <input style={s.input} type="email" value={form.empresa_email||''} onChange={e=>set('empresa_email',e.target.value)} /></div>
            <div style={s.field}><label style={s.label}>Logo (URL)</label>
              <input style={s.input} value={form.logo_url||''} onChange={e=>set('logo_url',e.target.value)} placeholder="https://..." />
              <div style={s.hint}>Sube tu logo y pega la URL aqui</div></div>
          </div>

          <div style={s.card}>
            <div style={s.cardTitle}>👥 Recursos Humanos</div>
            <div style={s.cardSub}>Horario laboral</div>
            <div style={s.twoCol}>
              <div style={s.field}><label style={s.label}>Horas jornada diaria</label>
                <div style={s.wrap}><input style={s.input} type="number" min="1" max="24" step="0.5" value={form.horas_jornada||8} onChange={e=>set('horas_jornada',parseFloat(e.target.value))} /><span style={s.unit}>h</span></div></div>
              <div style={s.field}><label style={s.label}>Zona horaria</label>
                <select style={s.input} value={form.zona_horaria||'Europe/Madrid'} onChange={e=>set('zona_horaria',e.target.value)}>
                  {ZONAS.map(z=><option key={z} value={z}>{z}</option>)}</select></div>
            </div>
            <div style={s.divider} />
            <div style={s.cardSub}>Vacaciones</div>
            <div style={s.twoCol}>
              <div style={s.field}><label style={s.label}>Dias anuales</label>
                <div style={s.wrap}><input style={s.input} type="number" min="0" max="60" value={form.dias_vacaciones_anuales||23} onChange={e=>set('dias_vacaciones_anuales',parseInt(e.target.value))} /><span style={s.unit}>dias</span></div></div>
              <div style={s.field}><label style={s.label}>Politica</label>
                <select style={s.input} value={form.politica_vacaciones||'no_acumula'} onChange={e=>set('politica_vacaciones',e.target.value)}>
                  <option value="no_acumula">No acumula</option>
                  <option value="acumula">Acumula al siguiente ano</option>
                  <option value="acumula_parcial">Acumula hasta 5 dias</option>
                </select></div>
            </div>
            <div style={s.divider} />
            <div style={s.cardSub}>Control de presencia</div>
            <div style={s.twoCol}>
              <div style={s.field}><label style={s.label}>Tolerancia de fichaje</label>
                <div style={s.wrap}><input style={s.input} type="number" min="0" max="60" value={form.tolerancia_minutos||15} onChange={e=>set('tolerancia_minutos',parseInt(e.target.value))} /><span style={s.unit}>min</span></div>
                <div style={s.hint}>Margen antes de marcar retraso</div></div>
              <div style={s.field}><label style={s.label}>Fichaje obligatorio</label>
                <select style={s.input} value={form.fichaje_obligatorio||'todos'} onChange={e=>set('fichaje_obligatorio',e.target.value)}>
                  <option value="todos">Todos los empleados</option>
                  <option value="internos">Solo internos</option>
                  <option value="ninguno">No obligatorio</option>
                </select></div>
            </div>
          </div>
        </div>

        {/* COLUMNA DERECHA */}
        <div style={s.col}>
          <div style={s.card}>
            <div style={s.cardTitle}>🔧 Modulos</div>
            <ToggleRow label="Fichajes" desc="Control de entradas y salidas" value={form.modulo_fichajes_activo} onChange={()=>set('modulo_fichajes_activo',!form.modulo_fichajes_activo)} />
            <ToggleRow label="Proyectos" desc="Gestion de proyectos, tareas e imputacion de horas" value={form.modulo_proyectos_activo} onChange={()=>set('modulo_proyectos_activo',!form.modulo_proyectos_activo)} />
            <ToggleRow label="Fichaje desde movil" desc="Permite fichar desde smartphones" value={form.fichaje_movil} onChange={()=>set('fichaje_movil',!form.fichaje_movil)} last />
          </div>

          <div style={s.card}>
            <div style={s.cardTitle}>🔔 Notificaciones</div>
            <ToggleRow label="Notificaciones por email" desc="Avisos importantes en tu correo" value={form.notificaciones_email} onChange={()=>set('notificaciones_email',!form.notificaciones_email)} />
            <ToggleRow label="Ausencia pendiente" desc="Email al admin cuando un empleado solicita ausencia" value={form.notif_ausencia_pendiente||false} onChange={()=>set('notif_ausencia_pendiente',!form.notif_ausencia_pendiente)} />
            <ToggleRow label="Respuesta a ausencia" desc="Email al empleado cuando se gestiona su solicitud" value={form.notif_ausencia_resuelta||false} onChange={()=>set('notif_ausencia_resuelta',!form.notif_ausencia_resuelta)} />
            <ToggleRow label="Aviso de retraso" desc="Alerta cuando un empleado supera la tolerancia" value={form.notif_retraso||false} onChange={()=>set('notif_retraso',!form.notif_retraso)} last />
          </div>

          <div style={{...s.card, background:'#f0f7ff', border:'0.5px solid #c8dff5'}}>
            <div style={s.cardTitle}>💳 Plan y facturacion</div>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',flexWrap:'wrap',gap:12}}>
              <div>
                <div style={{fontSize:11,color:'#888',textTransform:'uppercase',letterSpacing:'0.05em',marginBottom:4}}>Plan activo</div>
                <div style={{fontSize:20,fontWeight:700,color:'#1a1a1a',textTransform:'capitalize',marginBottom:4}}>
                  {form.plan || 'control'} <span style={{fontSize:13,fontWeight:400,color:'#888'}}>· {form.plan_precio}</span>
                </div>
                <div style={{marginBottom:6}}>
                  {form.estado_plan === 'pagado' && <span style={{background:'#EAF3DE',color:'#3B6D11',padding:'2px 10px',borderRadius:10,fontSize:12,fontWeight:500}}>● Activo</span>}
                  {form.estado_plan === 'trial' && <span style={{background:'#FFF8E6',color:'#B47B00',padding:'2px 10px',borderRadius:10,fontSize:12,fontWeight:500}}>⏳ Trial · {form.dias_trial} días restantes</span>}
                  {form.estado_plan === 'expirado' && <span style={{background:'#FCEBEB',color:'#A32D2D',padding:'2px 10px',borderRadius:10,fontSize:12,fontWeight:500}}>✕ Expirado</span>}
                </div>
                {form.estado_plan === 'trial' && form.trial_hasta && (
                  <div style={{fontSize:11,color:'#aaa'}}>Vence el {new Date(form.trial_hasta).toLocaleDateString('es-ES',{day:'numeric',month:'long',year:'numeric'})}</div>
                )}
                <div style={{fontSize:11,color:'#aaa',marginTop:4}}>Early Adopter · Precio especial de lanzamiento</div>
              </div>
              <div style={{display:'flex',flexDirection:'column',gap:6,alignItems:'flex-end'}}>
                <a href="mailto:hola@tempogestion.es?subject=Quiero cambiar mi plan" style={{background:'#378ADD',color:'white',padding:'8px 14px',borderRadius:8,textDecoration:'none',fontSize:13,fontWeight:500}}>Cambiar plan</a>
                <a href="mailto:hola@tempogestion.es?subject=Consulta facturacion" style={{color:'#378ADD',fontSize:12,textDecoration:'none'}}>Consultar facturacion</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function ConfigEmpleado({usuario}) {
  const [form, setForm] = useState({nombre: usuario?.nombre||'', email: usuario?.email||'', password_actual:'', password_nueva:'', password_confirmar:''});
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');
  const [guardando, setGuardando] = useState(false);

  const set = (key,val) => setForm(f=>({...f,[key]:val}));

  const guardar = async () => {
    setGuardando(true); setMsg(''); setError('');
    if (form.password_nueva && form.password_nueva !== form.password_confirmar) {
      setError('Las contrasenas no coinciden'); setGuardando(false); return;
    }
    if (form.password_nueva && form.password_nueva.length < 6) {
      setError('La contrasena debe tener al menos 6 caracteres'); setGuardando(false); return;
    }
    try {
      await API.put('/usuarios/me', {
        nombre: form.nombre,
        ...(form.password_nueva ? {password_nueva: form.password_nueva, password_actual: form.password_actual} : {})
      });
      setMsg('Datos actualizados correctamente');
      setForm(f=>({...f, password_actual:'', password_nueva:'', password_confirmar:''}));
    } catch(err) {
      setError(err.response?.data?.detail || 'Error al guardar');
    }
    setGuardando(false);
  };

  return (
    <>
      {msg && <div style={s.ok}>{msg}</div>}
      {error && <div style={s.err}>{error}</div>}
      <div style={{maxWidth:560}}>
        <div style={s.card}>
          <div style={s.cardTitle}>👤 Mis datos</div>
          <div style={s.field}><label style={s.label}>Nombre</label>
            <input style={s.input} value={form.nombre} onChange={e=>set('nombre',e.target.value)} /></div>
          <div style={s.field}><label style={s.label}>Email</label>
            <input style={s.input} value={form.email} disabled style={{...s.input, background:'#f5f5f3', color:'#aaa'}} />
            <div style={s.hint}>El email no se puede cambiar. Contacta con el administrador.</div></div>
        </div>

        <div style={{...s.card, marginTop:16}}>
          <div style={s.cardTitle}>🔒 Cambiar contrasena</div>
          <div style={s.field}><label style={s.label}>Contrasena actual</label>
            <input style={s.input} type="password" value={form.password_actual} onChange={e=>set('password_actual',e.target.value)} placeholder="Tu contrasena actual" /></div>
          <div style={s.field}><label style={s.label}>Nueva contrasena</label>
            <input style={s.input} type="password" value={form.password_nueva} onChange={e=>set('password_nueva',e.target.value)} placeholder="Minimo 6 caracteres" /></div>
          <div style={s.field}><label style={s.label}>Confirmar nueva contrasena</label>
            <input style={s.input} type="password" value={form.password_confirmar} onChange={e=>set('password_confirmar',e.target.value)} placeholder="Repite la nueva contrasena" /></div>
          <button style={guardando?s.btnOff:s.btn} onClick={guardar} disabled={guardando}>
            {guardando?'Guardando...':'Guardar cambios'}
          </button>
        </div>
      </div>
    </>
  );
}

export default function Configuracion() {
  const { usuario } = useAuth();
  const isAdmin = usuario?.rol === 'admin';
  const [form, setForm] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');

  useEffect(() => { if(isAdmin) cargar(); else setCargando(false); }, []);

  const cargar = async () => {
    setCargando(true);
    try {
      const res = await API.get('/configuracion');
      setForm(res.data);
    } catch(e) { console.error(e); }
    setCargando(false);
  };

  const guardar = async () => {
    setGuardando(true); setMsg(''); setError('');
    try {
      await API.put('/configuracion', form);
      setMsg('Configuracion guardada correctamente');
      setTimeout(()=>setMsg(''),3000);
    } catch(err) {
      setError(err.response?.data?.detail||'Error al guardar');
    }
    setGuardando(false);
  };

  const set = (key,val) => setForm(f=>({...f,[key]:val}));

  if (cargando) return <div style={s.loading}>Cargando...</div>;

  return (
    <div style={s.page}>
      <div style={s.topbar}>
        <div>
          <div style={{display:'flex',alignItems:'center',gap:8}}>
            <div style={s.topbarTitle}>Configuracion</div>
            {isAdmin && <span style={s.adminBadge}>Administrador</span>}
          </div>
          {isAdmin && form && <div style={s.topbarSub}>{form.empresa_nombre}</div>}
        </div>
        {isAdmin && <button style={guardando?s.btnOff:s.btn} onClick={guardar} disabled={guardando}>{guardando?'Guardando...':'Guardar cambios'}</button>}
      </div>

      <div style={s.content}>
        {isAdmin && form ? (
          <ConfigAdmin form={form} set={set} guardar={guardar} guardando={guardando} msg={msg} error={error} />
        ) : (
          <ConfigEmpleado usuario={usuario} />
        )}
      </div>
    </div>
  );
}

const s = {
  page:{display:'flex',flexDirection:'column',minHeight:'100vh',background:'#f5f5f3',fontFamily:'-apple-system,BlinkMacSystemFont,Inter,sans-serif'},
  loading:{display:'flex',alignItems:'center',justifyContent:'center',height:'100vh',color:'#aaa',fontSize:14},
  topbar:{background:'white',borderBottom:'0.5px solid #e0e0d8',padding:'0 24px',height:56,display:'flex',alignItems:'center',justifyContent:'space-between'},
  topbarTitle:{fontSize:14,fontWeight:600,color:'#1a1a1a'},
  topbarSub:{fontSize:12,color:'#aaa',marginTop:1},
  adminBadge:{background:'#EAF3DE',color:'#3B6D11',fontSize:11,padding:'2px 8px',borderRadius:10,fontWeight:600},
  content:{padding:24,width:'100%',boxSizing:'border-box'},
  cols:{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16,alignItems:'start'},
  col:{display:'flex',flexDirection:'column',gap:16},
  card:{background:'white',border:'0.5px solid #e0e0d8',borderRadius:12,padding:24},
  cardTitle:{fontSize:14,fontWeight:600,color:'#1a1a1a',marginBottom:20},
  cardSub:{fontSize:11,fontWeight:600,color:'#888',textTransform:'uppercase',letterSpacing:'0.05em',marginBottom:14},
  divider:{borderTop:'0.5px solid #f0f0ed',margin:'18px 0'},
  twoCol:{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12},
  field:{marginBottom:12},
  label:{display:'block',fontSize:13,color:'#444',marginBottom:5,fontWeight:500},
  input:{width:'100%',padding:'9px 12px',borderRadius:8,border:'0.5px solid #d0d0c8',fontSize:14,outline:'none',boxSizing:'border-box',background:'white'},
  wrap:{position:'relative'},
  unit:{position:'absolute',right:10,top:'50%',transform:'translateY(-50%)',fontSize:12,color:'#aaa',pointerEvents:'none'},
  hint:{fontSize:11,color:'#aaa',marginTop:3},
  btn:{background:'#378ADD',color:'white',border:'none',borderRadius:8,padding:'9px 18px',fontSize:13,fontWeight:500,cursor:'pointer'},
  btnOff:{background:'#a0c4e8',color:'white',border:'none',borderRadius:8,padding:'9px 18px',fontSize:13,cursor:'not-allowed'},
  ok:{background:'#EAF3DE',color:'#3B6D11',borderRadius:8,padding:'10px 14px',fontSize:13,marginBottom:16},
  err:{background:'#FCEBEB',color:'#A32D2D',borderRadius:8,padding:'10px 14px',fontSize:13,marginBottom:16},
};
